import deepEquals from '../../../Lib/Object/deepEquals';

export const SHAPE_CIRCULAR = 'circular';
export const SHAPE_RECTANGULAR = 'rectangular';
export const SIZE_OPTION_CUSTOM_CIRCULAR = 'custom_circular';
export const SIZE_OPTION_CUSTOM_RECTANGULAR = 'custom_rectangular';
export const UNITS_METRIC = 'Metric';
export const UNITS_INCH_POUND = 'Inch-Pound';

const predefinedSieveSetSizes = {
  [UNITS_METRIC]: [
    {
      value: '200mm_diameter',
      label: '200 mm Diameter',
      dimensions: {
        Shape: SHAPE_CIRCULAR,
        Diameter: { value: '200', uom: 'mm' },
      },
    },
    {
      value: '300mm_diameter',
      label: '300 mm Diameter',
      dimensions: {
        Shape: SHAPE_CIRCULAR,
        Diameter: { value: '300', uom: 'mm' },
      },
    },
    {
      value: '450mm_diameter',
      label: '450 mm Diameter',
      dimensions: {
        Shape: SHAPE_CIRCULAR,
        Diameter: { value: '450', uom: 'mm' },
      },
    },
  ],
  [UNITS_INCH_POUND]: [
    {
      value: '8in_diameter',
      label: '8″ (200 mm) Diameter',
      dimensions: {
        Shape: SHAPE_CIRCULAR,
        Diameter: { value: '8', uom: 'in' },
      },
    },
    {
      value: '10in_diameter',
      label: '10″ (254 mm) Diameter',
      dimensions: {
        Shape: SHAPE_CIRCULAR,
        Diameter: { value: '10', uom: 'in' },
      },
    },
    {
      value: '12in_diameter',
      label: '12″ (305 mm) Diameter',
      dimensions: {
        Shape: SHAPE_CIRCULAR,
        Diameter: { value: '12', uom: 'in' },
      },
    },
    {
      value: '13.8in_by_13.8in',
      label: '13.8″ by 13.8″ (350 mm by 350 mm)',
      dimensions: {
        Shape: SHAPE_RECTANGULAR,
        Length: { value: '13.8', uom: 'in' },
        Width: { value: '13.8', uom: 'in' },
      },
    },
    {
      value: '14.6in_by_22.8in',
      label: '14.6″ by 22.8″ (370 mm by 580 mm)',
      dimensions: {
        Shape: SHAPE_RECTANGULAR,
        Length: { value: '14.6', uom: 'in' },
        Width: { value: '22.8', uom: 'in' },
      },
    },
  ],
};

const customisableSieveSetSizeOptions = [
  {
    value: SIZE_OPTION_CUSTOM_CIRCULAR,
    label: 'Custom Circular Sieves',
    dimensions: {
      Shape: SHAPE_CIRCULAR,
    },
  },
  {
    value: SIZE_OPTION_CUSTOM_RECTANGULAR,
    label: 'Custom Rectangular Sieves',
    dimensions: {
      Shape: SHAPE_RECTANGULAR,
    },
  },
];

export const getSieveSetUnitsOptions = () => [UNITS_INCH_POUND, UNITS_METRIC].map((e) => ({ label: e, value: e }));

export const getSieveSetSizeOptions = (units) =>
  (predefinedSieveSetSizes[units] ?? []).concat(customisableSieveSetSizeOptions);

export const getPredefinedLabelForSieveSetDimensions = (sieveSetDimensions, units) =>
  predefinedSieveSetSizes[units]?.find((d) => deepEquals(d.dimensions, sieveSetDimensions))?.label;

export const getSieveSetSizeOptionValueForDimensions = (sieveSetDimensions, units) =>
  // First try to find a match within the predefined dimensions.
  predefinedSieveSetSizes[units]?.find((d) => deepEquals(d.dimensions, sieveSetDimensions))?.value ??
  // Fall back to the customisable option for the sieve shape.
  customisableSieveSetSizeOptions.find((d) => d.dimensions.Shape === sieveSetDimensions?.Shape)?.value;
